import { Routes } from './routes';
import { BrowserRouter } from 'react-router';

import './App.css';

export const App = () => (
  <BrowserRouter>
    <Routes />
  </BrowserRouter>
);
